import { Row } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import ContentBox from '@shared/ContentBox'
import { useTranslation } from 'react-i18next'
import PosReportingFilterBar from './blocks/PosReportingFilterBar'
function PostReport() {
  const { t } = useTranslation()

  return (
    <ContentBox title={t('home.posreport')}>
      <Row style={{ flexDirection: 'column', gap: 20, minHeight: '100vh' }}>
        <PosReportingFilterBar />
      </Row>
    </ContentBox>
  )
}

const mapStateToProps = (state: any) => {
  return {
    leftMenuStatus: state.home.leftMenuStatus,
  }
}

export default connect(mapStateToProps, null)(PostReport)
